import createFocusTrap from 'focus-trap';
import BaseComponent from 'foundation/base-component';
import anime from 'animejs';
import gtm from 'general/js/gtm';
import contentBlocker from '../../../general/js/content-blocker';

const EDITOR = 'editor';
const EASING_DEFAULT = 'linear';
const EASING = 'easeOutQuad';
const DURATION_DEFAULT = 400;

export default class MainNavComponent extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.focusTrap = null;
        this.menuCanBeAnimated = true;

        this.init();

        this.setFocusTrap = this.setFocusTrap.bind(this);
    }

    static getRequiredRefs() {
        return [
            'nav',
            'wrapper',
            'opener',
        ];
    }

    init() {
        this.refs.closers.forEach((button) => {
            this.addListener(button, 'click', this.closeMenu);
        });

        this.addListener(this.refs.opener, 'click', this.openMenu);
        this.addListener(this.refs.nav, 'click', this.saveActionToGtm);

        this.addListener(document, 'keydown', this.onkeydown);
        this.addListener(document, 'click', this.outerClickHandle);
        this.addListener(document, 'touchstart', this.outerClickHandle);
    }

    saveActionToGtm = (event) => {
        const clickedItem = event.target;
        const itemText = clickedItem.innerText || clickedItem.textContent;

        if (clickedItem && clickedItem.tagName === 'A') {
            gtm.push('Burger Bar', 'Click', itemText);
        }       
    }
    
    openMenu = () => {
        contentBlocker.block('main-nav');

        gtm.push('Burger Bar', 'Open', 'Burger Bar Open');

        if (this.menuCanBeAnimated) {
            this.menuCanBeAnimated = false;
            anime({
                targets: this.refs.nav,
                opacity: [0, 1],
                duration: DURATION_DEFAULT,
                easing: EASING,
                begin: () => {
                    this.refs.nav.classList.add('is-opened');
                },
                complete: () => {
                    this.refs.wrapper.classList.add('is-visible');
                    this.refs.nav.setAttribute('aria-hidden', 'false');
                    this.refs.opener.setAttribute('aria-expanded', 'true');
                    this.menuCanBeAnimated = true;
                    this.setFocusTrap();
                }
            });
        }
    };

    closeMenu = () => {
        contentBlocker.unblock('main-nav');
        this.refs.wrapper.classList.remove('is-visible');

        if (this.menuCanBeAnimated) {
            this.menuCanBeAnimated = false;
            anime({
                targets: this.refs.nav,
                opacity: [1, 0],
                duration: DURATION_DEFAULT,
                easing: EASING_DEFAULT,
                complete: () => {
                    this.refs.nav.classList.remove('is-opened');
                    this.refs.nav.setAttribute('aria-hidden', 'true');
                    this.refs.opener.setAttribute('aria-expanded', 'false');
                    this.menuCanBeAnimated = true;
                }
            });
        }

        this.removeFocusTrap();
    };

    setFocusTrap() {
        if (this.options.mode !== EDITOR) {
            this.focusTrap = createFocusTrap(this.refs.nav, {
                escapeDeactivates: false
            });
            this.focusTrap.activate();
        }
    }

    removeFocusTrap() {
        if (this.focusTrap) {
            this.focusTrap.deactivate();
        }
    }

    onkeydown = (event) => {
        if (event.keyCode === 27) {
            this.closeMenu();
        }
    };

    outerClickHandle = (event) => {
        if (this.refs.nav.contains(event.target) &&
            !this.refs.wrapper.contains(event.target)) {
            this.closeMenu();
        }
    };
}
